import { Injectable, signal, Signal } from "@angular/core";
import GeobusNavigationExtension from "./geobus-navigation.extension";
import { IType } from "@geolib/geoappbase-client";


@Injectable({ providedIn: "root" })
export default class GeobusToDoExtension extends GeobusNavigationExtension {

    public get component(): IType<unknown> | null {
        return null;
    }

    public get identifier(): string | null {
        return "GeobusToDoExtensionName";
    }

    public get title(): Signal<string> {
        return signal("SIDE_MENU.GENERAL.TO_DO").asReadonly();
    }

    public get category(): string {
        return "general";
    }

    public get state(): { name: string } {
        return { name: "app.main" };
    }

    public get icon(): string {
        return "done";
    }

}
